export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";